import { render } from "./CreateUser.vue?vue&type=template&id=af4e0bb2&ts=true"
import script from "./CreateUser.vue?vue&type=script&lang=ts"
export * from "./CreateUser.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__